import {
  getAllValuesAndNamesFromUrl,
  getAllVariantDataObjectsFromUrl,
  getFieldsetOptions,
} from "../utils/inputs";
import { listenForVariantOptionsChanges } from "@surf-turf/nemo/assets/utils-events";

class ProductSpecs extends HTMLElement {
  constructor() {
    super();

    const productSpecsElement = this;
    const productSpecsContentElement = productSpecsElement.querySelector(
      ".product-specs__inner"
    );

    /**
     * Create specs list from variant object.
     *
     * @param {object} variantDataObject
     *
     * @returns {object}
     */
    const createSpecsListFromVariantObject = (variantDataObject) => {
      const variantOptionTitles = variantDataObject?.option_titles.split(" - ");
      const variantOptionValues = variantDataObject?.options.split(" - ");
      const arrayOfOptionTitlesAndValues = variantOptionTitles?.map(
        (optionTitle, index) =>
          `<span>${optionTitle}:</span> ${variantOptionValues[index]}`
      );

      const goldGrams = variantDataObject?.gold_grams;
      const karats = variantDataObject?.karats;

      if (variantDataObject) {
        return {
          product: variantDataObject?.title,
          title: variantDataObject?.product_title,
          arrayOfOptionTitlesAndValues,
          measurements: variantDataObject?.measurements,
          type: variantDataObject?.product_type,
          "solid gold": goldGrams,
          "lab-diamond": karats,
        };
      } else {
        return false;
      }
    };
    // console.log(createSpecsListFromVariantObject(variantDataObject));
    /**
     * Create HTML from specs list
     *
     * @param {object} specsList
     *
     * @returns {object}
     */
    const createHtmlFromSpecsList = (specsList) => {
      const propertiesListItem = specsList.arrayOfOptionTitlesAndValues?.map(
        (optionTitleAndValue) => `<li>${optionTitleAndValue}</li>`
      );
      const TCW = (Math.round(specsList["lab-diamond"] * 100) / 100).toFixed(2);
      const solidGold = (
        Math.round(specsList["solid gold"] * 100) / 100
      ).toFixed(2);
      return `
        <h6>${specsList.title}</h6>
        <ul>
          ${
            specsList.measurements
              ? `<li><small>Measurements:</small> <span>${specsList.measurements}mm</span></li>`
              : ""
          }
          ${
            specsList["lab-diamond"]
              ? `<li><small>Lab-Diamond:</small> <span>Carat: ${TCW}cts 
              <small>(per ${
                specsList.title.includes("Stud") ? 'Stud' : 
                specsList.title.includes("Clasp") ? 'Clasp' :
                (specsList.title.includes("Chain") ? 'Chain' : specsList.title)
            })</small>
              <br>
              
              Color: D-G<br>Clarity: VS+<br>Cut: excellent</span></li>`
              : ""
          }
          ${specsList["solid gold"]
          ? `<li><small>Solid Gold:</small> <span>Metal: solid 14K gold<br>Weight: ${solidGold} gr <small>(per ${
              specsList.title.includes("Stud") ? 'Stud' : 
              specsList.title.includes("Clasp") ? 'Clasp' :
              (specsList.title.includes("Chain") ? 'Chain' : specsList.title)
          })</small></span></li>`
          : ""
        }        
          
        </ul>
      `;

      return `
        <h6>${specsList.title}</h6>
        <ul>
          ${propertiesListItem?.join("")}
          ${
            specsList["lab-diamond"]
              ? `<li><span>lab-diamond:</span> ${TCW}cts</li>`
              : ""
          }
          ${
            specsList["solid gold"]
              ? `<li><span>solid gold:</span> ${solidGold} gr</li>`
              : ""
          }
          ${
            specsList.measurements
              ? `<li><span>measurements:</span> ${specsList.measurements}mm</li>`
              : ""
          }
        </ul>
      `;
    };

    // getAllVariantDataObjectsFromUrl

    const handleUpdateProductSpecs = () => {
      if (productSpecsElement.dataset.disableJs === "true") {
        productSpecsContentElement.innerHTML = "";

        // Get all products that are in the set.
        const allVariantObjects = [];
        productSpecsElement
          .querySelectorAll(".in-set-product-data")
          .forEach((inSetProductData) => {
            const inSetProductDataObject = inSetProductData? JSON.parse(inSetProductData.innerHTML).variants : null;
            const correctVariantObjects = getAllVariantDataObjectsFromUrl();
            const selectedVariantOptionsString =
              correctVariantObjects?.mainProduct?.options;
            let inSetProductVariantObject = inSetProductDataObject.find(
              (variantObject) =>
                variantObject.options.includes(selectedVariantOptionsString)
            );
            // Find corret variant.

            if (inSetProductVariantObject) {
              // If the product variant is found it will continue with this fount product variant object.
            } else {
              // If the product variant is not found it will continue with the first product variant object.
              inSetProductVariantObject = inSetProductDataObject[0];
            }

            allVariantObjects.push(inSetProductVariantObject);
          });

        const htmlStringElementsOfProductSpecs = allVariantObjects.map(
          (variantObject) => {
            if (variantObject && Object.keys(variantObject).length > 0) {
              const specsListObject =
                createSpecsListFromVariantObject(variantObject);
              const htmlStringElementsOfSpecsList =
                createHtmlFromSpecsList(specsListObject);

              return htmlStringElementsOfSpecsList;
            }
          }
        );

        // Set all html sting elements of product specs in the product specs element.
        htmlStringElementsOfProductSpecs.map((htmlString) => {
          productSpecsContentElement.insertAdjacentHTML(
            "beforeend",
            htmlString
          );
        });
      } else {
        productSpecsContentElement.innerHTML = "";
        const correctVariantObjects = getAllVariantDataObjectsFromUrl();

        if (!correctVariantObjects) {
          return null;
        }
        const connectedProductVariantObject =
          correctVariantObjects.connectedProducts
            ? [...correctVariantObjects.connectedProducts]
            : null;
        const mainProductVariantObject = correctVariantObjects.mainProduct
          ? correctVariantObjects.mainProduct
          : null;
        const allVariantObjects = [
          ...connectedProductVariantObject,
          mainProductVariantObject,
        ];
        let htmlStringElementsOfProductSpecs = allVariantObjects.map(
          (variantObject) => {
            if (variantObject && Object.keys(variantObject).length > 0) {
              const specsListObject =
                createSpecsListFromVariantObject(variantObject);
              const htmlStringElementsOfSpecsList =
                createHtmlFromSpecsList(specsListObject);
              return htmlStringElementsOfSpecsList;
            }
          }
        );

        // Set all html sting elements of product specs in the product specs element.
        htmlStringElementsOfProductSpecs =
          htmlStringElementsOfProductSpecs.filter(Boolean);
        htmlStringElementsOfProductSpecs.map((htmlString) => {
          productSpecsContentElement.insertAdjacentHTML(
            "beforeend",
            htmlString
          );
        });
      }
    };

    listenForVariantOptionsChanges(() => {
      handleUpdateProductSpecs();
    });

    // Initial load
    handleUpdateProductSpecs();
  }
}

// Check if element is defined, if not define it..
// eslint-disable-next-line no-undefined
if (customElements.get("product-specs") === undefined) {
  customElements.define("product-specs", ProductSpecs);
}
